import script from "./JournalBook.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalBook.vue?vue&type=script&setup=true&lang=js"

import "./JournalBook.vue?vue&type=style&index=0&id=442f7d62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-442f7d62"]])

export default __exports__